import { Injectable, signal } from '@angular/core'
import { StudentGroupContent } from './student-group-content.utils'

@Injectable({
  providedIn: 'root',
})
export class StudentGroupContentService {
  readonly studentGroupContent = signal<StudentGroupContent | null>(null)

  setStudentGroupContent(content: StudentGroupContent | null) {
    this.studentGroupContent.set(content)
  }

  clearStudentGroupContent() {
    this.studentGroupContent.set(null)
  }
}
